import config from "../config";
import { ScheduleEntry } from "../Model/ImagingSchedule";
import { sendPostRequest } from "./../Utility/FetchUtils";

class SchedulingApi {
  static BASE_URL = config.SERVICE_URL + "/scheduling";

  static setPriority(scheduleEntry: ScheduleEntry, priority: number) {
    const url = `${SchedulingApi.BASE_URL}/:set-priority/${priority}`;
    return sendPostRequest(url,scheduleEntry);
  }

  static doCancelSchedules(scheduleEntries: ScheduleEntry[]) {
    const url = `${SchedulingApi.BASE_URL}/:cancel-schedules`;
    return sendPostRequest(url, scheduleEntries);
  }

  static doStartSchedules(scheduleEntries: ScheduleEntry[]) {
    const url = `${SchedulingApi.BASE_URL}/:start-schedules`;
    return sendPostRequest(url, scheduleEntries);
  }

  static doStopSchedules(scheduleEntries: ScheduleEntry[]) {
    const url = `${SchedulingApi.BASE_URL}/:stop-schedules`;
    return sendPostRequest(url, scheduleEntries);
  }

  static promoteSchedule(scheduleEntries: ScheduleEntry[]) {
    const url = `${SchedulingApi.BASE_URL}/:promote`;
    return sendPostRequest(url, scheduleEntries);
  }

  static demoteSchedule(scheduleEntries: ScheduleEntry[]) {
    const url = `${SchedulingApi.BASE_URL}/:demote`;
    return sendPostRequest(url, scheduleEntries);
  }
}

export default SchedulingApi;
